import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import SearchCustomersTable from '../Components/SearchCustomersTable';

const SearchCustomersPage = () => {
    return (
        <Container>
            <Box my={4}>
                <Typography variant="h4" component="h1" gutterBottom>
                Псевдонимы для поиска заказчиков/группа заказчиков
                </Typography>
                <SearchCustomersTable />
            </Box>
        </Container>
    );
};

export default SearchCustomersPage;
